import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type IsValidRangeForPartnerProps = {
  partnerId: string;
  holdingClassId: string;
  shareFrom: number;
  shareTo: number;
};

export const isValidRangeForPartner =
  ({
    partnerId,
    holdingClassId,
    shareFrom,
    shareTo,
  }: IsValidRangeForPartnerProps) =>
  async (dispatch: any) => {
    const query = { params: { partnerId, holdingClassId, shareFrom, shareTo } };

    try {
      const { data } = await axiosV2.get('/partners/isValidRange', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
